module.exports = __webpack_public_path__ + "assets/01.c152ccd4.pdf";